export default "__VITE_ASSET__CK9U3cAO__"